import {
  Theme,
  TypographyVariant,
  WithTheme,
  assertTheme,
  interpolateRhythmMargin,
} from '@mint/core';
import { ControlText } from '../typography';
import { ListItemTextProps } from './list-item-text-props';
import PropTypes from 'prop-types';
import React from 'react';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'list-item-text';

/**
 * List component implementation before styling.
 */
export const ListItemTextComponent = React.forwardRef<any, ListItemTextProps>(
  (props, ref): React.ReactElement => {
    const { children, className, ...rest } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <ControlText {...componentProps}>{children}</ControlText>;
  },
);

ListItemTextComponent.displayName = 'ListItemText';

export const ListItemText = styled(ListItemTextComponent)`
  margin-top: 0;
`;
